<script lang="ts">
  import type { HTMLInputValidationProps } from '../types/props';
  import MediaBlock from './MediaBlock.svelte';
  import Icon from './Icon.svelte';
  import Tooltip from './Tooltip.svelte';

  export let validation: HTMLInputValidationProps = { rules: [] };
</script>

<div class="flex justify-end">
  <Tooltip placement="bottom" width="w-full md:w-auto" textCenter={false} variant="error">
    <div class="space-y-3">
      {#if validation.description}
        <div class="font-bold">{validation.description}</div>
      {/if}
      <div class="space-y-2">
        {#each validation.rules as { label, valid }}
          <div>
            <MediaBlock vAlign="center" classNames="space-x-3">
              <div slot="end">
                <Icon
                  size="small"
                  classNames={valid ? 'text-success' : 'text-danger'}
                  name={valid ? 'valid' : 'warning'}
                />
              </div>
              {label}
            </MediaBlock>
          </div>
        {/each}
      </div>
    </div>
  </Tooltip>
</div>
